import React from "react";

function DesignerIcon() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3173 24V28H19.6827V24L21.792 19.7227L16.5 12L11.208 19.7227L13.3173 24Z"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8587 7.19043H15.1921C14.8241 7.19043 14.5254 6.89176 14.5254 6.52376V3.8571C14.5254 3.4891 14.8241 3.19043 15.1921 3.19043H17.8587C18.2267 3.19043 18.5254 3.4891 18.5254 3.8571V6.52376C18.5254 6.89176 18.2267 7.19043 17.8587 7.19043Z"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.18815 19.417H6.85482C7.22282 19.417 7.52148 19.1183 7.52148 18.7503V16.0837C7.52148 15.7157 7.22282 15.417 6.85482 15.417H4.18815C3.82015 15.417 3.52148 15.7157 3.52148 16.0837V18.7503C3.52148 19.1183 3.82015 19.417 4.18815 19.417Z"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.8079 19.417H26.1413C25.7733 19.417 25.4746 19.1183 25.4746 18.7503V16.0837C25.4746 15.7157 25.7733 15.417 26.1413 15.417H28.8079C29.1759 15.417 29.4746 15.7157 29.4746 16.0837V18.7503C29.4746 19.1183 29.1759 19.417 28.8079 19.417Z"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5258 5.2666C9.44178 5.85993 5.49512 10.1746 5.49512 15.4173"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5014 15.4171C27.5014 10.1931 23.5814 5.89175 18.5254 5.27441"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3135 23.9997H19.6868"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4997 20V12"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DesignerIcon;
